export default __webpack_public_path__ + "static/tabla-de-posiciones-large-a0dc68d64e41d3231ef62795b3c9485e.svg";